export const getIsExpiredToken = (time) => {
  const timeNow = Math.round(Date.now() / 1000)
  return time - timeNow <= 86400
}
